import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Edit, BookOpen } from "lucide-react";

export default function AdminGuidesList() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get("/admin/guides")
      .then((r) => setGuides(r.data))
      .catch((err) => {
        if (err.response?.status === 401) navigate("/admin/login");
      })
      .finally(() => setLoading(false));
  }, [user, navigate]);

  return (
    <div>
      <div className="mb-8">
        <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#CC1A1A] mb-1">// GUIDES</p>
        <h1 className="font-mono text-xl text-white uppercase tracking-tight">Intel Guides</h1>
        <p className="text-[#555] font-mono text-xs mt-1 tracking-wide">Edit guide content — changes go live immediately.</p>
      </div>

      {loading ? (
        <p className="font-mono text-[#666] text-xs tracking-widest animate-pulse">// LOADING…</p>
      ) : (
        <div className="space-y-2">
          {guides.map((g) => (
            <div
              key={g.slug}
              className="flex items-center justify-between bg-[#0B0B0B] border border-[#2A2A2A] px-5 py-4 hover:border-[#CC1A1A] transition-colors"
            >
              <div className="flex items-center gap-4 min-w-0">
                <BookOpen className="w-4 h-4 text-[#CC1A1A] shrink-0" />
                <div className="min-w-0">
                  <p className="font-mono text-white text-sm uppercase tracking-wide truncate">{g.title}</p>
                  <p className="font-mono text-[#555] text-[10px] tracking-widest mt-0.5">/guides/{g.slug}</p>
                </div>
              </div>
              <div className="flex items-center gap-4 shrink-0 ml-4">
                <span className={`font-mono text-[10px] tracking-widest uppercase ${g.published ? "text-[#4CAF50]" : "text-[#555]"}`}>
                  {g.published ? "LIVE" : "DRAFT"}
                </span>
                <Link
                  to={`/admin/guides/${g.slug}`}
                  className="flex items-center gap-1.5 font-mono text-[11px] tracking-widest uppercase text-[#9A8F83] hover:text-white transition-colors"
                >
                  <Edit className="w-3 h-3" /> EDIT
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
